import { ActionBus, GameState, Secret } from 'game-logic';

export enum GameInterfaceState {
  GameLoading,
  GameWaiting,
  GameStarting,
  GameStarted,
}

export enum GameFinishState {
  UserFinish,
  GameComplete,
  DeadlineTimeout,
}

export type UxGameActions = {
  onGameLoaded: void;
  onStartGame: void;
  onScoreChange: { score: number };
  onNewMove: { moves: string[] };
  onGameStateChange: { state: GameState };
  onGameComplete: { moves: string[]; isComplete: boolean };
};

export interface UxGameListener {
  get gameActions(): ActionBus<UxGameActions>;

  setSecretFetcher(fetcher: (indexes: number[]) => Promise<Secret[]>): void;
}
